// require('./bootstrap');

$(function() {
    $('.image').lazy();
})

require('./slider-before-after');

require('./slick-carousel');

require('./main');